import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    // Récupérer le panier du localStorage au chargement
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Sauvegarder le panier dans localStorage à chaque modification
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
    setCart(prevCart => {
        // Crée une copie de l'objet produit sans le prix
        const productWithoutPrice = { 
            ...product, 
            prix: undefined, // Retirer explicitement le prix
        };

        const existingProduct = prevCart.find(item => item.id_prod === product.id_prod);
        
        if (existingProduct) {
            // Si le produit existe déjà, augmenter la quantité
            return prevCart.map(item =>
                item.id_prod === product.id_prod
                    ? { ...item, quantity: item.quantity + 1 }
                    : item
            );
        }

        // Si le produit n'existe pas, l'ajouter avec une quantité de 1
        return [...prevCart, { ...productWithoutPrice, quantity: 1 }];
    });
};

const getCartCount = () => {
  return cart.reduce((total, item) => total + item.quantity, 0);
};
  const removeFromCart = (productId) => {
    setCart(prevCart => prevCart.filter(item => item.id_prod !== productId));
  };

  const updateQuantity = (productId, quantity) => {
    setCart(prevCart =>
      prevCart.map(item =>
        item.id_prod === productId
          ? { ...item, quantity: Math.max(0, quantity) }
          : item
      )
    );
  };

  const clearCart = () => {
    setCart([]);
  };
  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        getCartCount,
     
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};